import React,{Component} from 'react';

import Social from './Social';

import './Footer.less';

const Footer = ({data,showImpressum}) => (
 <div id="footer">
    <div className="wrapper">
    <div className='social-wrapper'><Social style={{display: 'flex',  justifyContent: 'center'}} data={data} /></div>
    <div id="credits">
    Copyright 2017 the Prosecution &middot; <span onClick={showImpressum}>Impressum</span>
    <div className='premote'>powered by premote</div>
    <div className="initiativemusik">
    <img src="/img/sonstige/initiative_musik_footer.svg" alt="Initiative Musik"  />
    Gefördert durch die Initiative Musik gemeinnützige Projektgesellschaft mbH mit Projektmitteln der Beauftragten der Bundesregierung für Kultur und Medien.
    </div>
    </div>
    </div>

  </div>


)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js